import * as Types from '../../@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddGoGoLiveParentGuideMutationVariables = Types.Exact<{
  contentId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  serviceType?: Types.InputMaybe<Types.Scalars['String']['input']>;
  yearAndMonth: Types.Scalars['String']['input'];
  levelId: Types.Scalars['String']['input'];
  sessions: Array<Types.GoGoLiveSessionInfoInput> | Types.GoGoLiveSessionInfoInput;
  lessonTitle: Types.Scalars['String']['input'];
  previewVideoVimeoId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  previewVideoCoverImageFileName: Types.Scalars['String']['input'];
  introduction: Types.Scalars['String']['input'];
  learningGoals: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
  languagePoint: Types.Scalars['String']['input'];
  bookPage?: Types.InputMaybe<Types.Scalars['String']['input']>;
  songList: Array<Types.GoGoLiveParentGuideSongInfoInput> | Types.GoGoLiveParentGuideSongInfoInput;
  wordList: Array<Types.TalkAlongCardInfoInput> | Types.TalkAlongCardInfoInput;
  toys?: Types.InputMaybe<Array<Types.GoGoLiveToyInfoInput> | Types.GoGoLiveToyInfoInput>;
  showAndTell?: Types.InputMaybe<Types.Scalars['String']['input']>;
  printableSheet?: Types.InputMaybe<Types.Scalars['String']['input']>;
  user: Types.Scalars['String']['input'];
  isNotifyTeams?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type AddGoGoLiveParentGuideMutation = { __typename?: 'Mutation', addGoGoLiveParentGuide: { __typename?: 'ResultResponse', count: number, error?: string | null } };


export const AddGoGoLiveParentGuideDocument = gql`
    mutation AddGoGoLiveParentGuide($contentId: Int, $serviceType: String, $yearAndMonth: String!, $levelId: String!, $sessions: [GoGoLiveSessionInfoInput!]!, $lessonTitle: String!, $previewVideoVimeoId: String, $previewVideoCoverImageFileName: String!, $introduction: String!, $learningGoals: [String!]!, $languagePoint: String!, $bookPage: String, $songList: [GoGoLiveParentGuideSongInfoInput!]!, $wordList: [TalkAlongCardInfoInput!]!, $toys: [GoGoLiveToyInfoInput!], $showAndTell: String, $printableSheet: String, $user: String!, $isNotifyTeams: Boolean) {
  addGoGoLiveParentGuide(
    request: {contentId: $contentId, serviceType: $serviceType, yearAndMonth: $yearAndMonth, levelId: $levelId, sessions: $sessions, lessonTitle: $lessonTitle, previewVideoVimeoId: $previewVideoVimeoId, previewVideoCoverImageFileName: $previewVideoCoverImageFileName, introduction: $introduction, learningGoals: $learningGoals, languagePoint: $languagePoint, bookPage: $bookPage, songList: $songList, wordList: $wordList, toys: $toys, showAndTell: $showAndTell, printableSheet: $printableSheet, user: $user, isNotifyTeams: $isNotifyTeams}
  ) {
    count
    error
  }
}
    `;
export type AddGoGoLiveParentGuideMutationFn = Apollo.MutationFunction<AddGoGoLiveParentGuideMutation, AddGoGoLiveParentGuideMutationVariables>;

/**
 * __useAddGoGoLiveParentGuideMutation__
 *
 * To run a mutation, you first call `useAddGoGoLiveParentGuideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGoGoLiveParentGuideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGoGoLiveParentGuideMutation, { data, loading, error }] = useAddGoGoLiveParentGuideMutation({
 *   variables: {
 *      contentId: // value for 'contentId'
 *      serviceType: // value for 'serviceType'
 *      yearAndMonth: // value for 'yearAndMonth'
 *      levelId: // value for 'levelId'
 *      sessions: // value for 'sessions'
 *      lessonTitle: // value for 'lessonTitle'
 *      previewVideoVimeoId: // value for 'previewVideoVimeoId'
 *      previewVideoCoverImageFileName: // value for 'previewVideoCoverImageFileName'
 *      introduction: // value for 'introduction'
 *      learningGoals: // value for 'learningGoals'
 *      languagePoint: // value for 'languagePoint'
 *      bookPage: // value for 'bookPage'
 *      songList: // value for 'songList'
 *      wordList: // value for 'wordList'
 *      toys: // value for 'toys'
 *      showAndTell: // value for 'showAndTell'
 *      printableSheet: // value for 'printableSheet'
 *      user: // value for 'user'
 *      isNotifyTeams: // value for 'isNotifyTeams'
 *   },
 * });
 */
export function useAddGoGoLiveParentGuideMutation(baseOptions?: Apollo.MutationHookOptions<AddGoGoLiveParentGuideMutation, AddGoGoLiveParentGuideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddGoGoLiveParentGuideMutation, AddGoGoLiveParentGuideMutationVariables>(AddGoGoLiveParentGuideDocument, options);
      }
export type AddGoGoLiveParentGuideMutationHookResult = ReturnType<typeof useAddGoGoLiveParentGuideMutation>;
export type AddGoGoLiveParentGuideMutationResult = Apollo.MutationResult<AddGoGoLiveParentGuideMutation>;
export type AddGoGoLiveParentGuideMutationOptions = Apollo.BaseMutationOptions<AddGoGoLiveParentGuideMutation, AddGoGoLiveParentGuideMutationVariables>;